import React, { createContext, useState, useEffect,useContext } from 'react';
import Notiflix from "notiflix";
import { useNavigate } from 'react-router-dom';
import { endpoint } from './endpoint';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
	
    const navigate = useNavigate();

    useEffect(() => {
        const validateToken = async () => {
            const token = localStorage.getItem('authToken');
            if (token) {
                try {
                    const response = await fetch(`${endpoint}/gymapp/validateToken.php`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ token }),
                    });

                    const data = await response.json();

                    if (data.status === 'success') {
                        const storedUser = JSON.parse(localStorage.getItem("userData"));
                        if (storedUser) {
                            setUser(storedUser);
                            setIsAuthenticated(true);
                        } else {
                            // Handle case where user data is not available
                            localStorage.removeItem('authToken');
                            localStorage.removeItem('userData');
                            navigate('/login');
                        }
                    } else {
                        localStorage.removeItem('authToken');
                        localStorage.removeItem('userData');
                        navigate('/login');
                    }
                } catch (error) {
                    Notiflix.Report.failure('An error occurred while validating the token. Please try again.');
                }
            } else {
               // navigate('/login');
            }
        };

        validateToken();
    }, [navigate]);

    const loginUser = async (email, password) => {
        setIsLoading(true);
        try {
            const response = await fetch(`${endpoint}/gymapp/login.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });

            const data = await response.json();

            if (data.status === 'success') {
                localStorage.setItem('authToken', data.user.token);
                localStorage.setItem('userData', JSON.stringify(data.user));
                setUser(data.user);
                setIsAuthenticated(true);
                navigate('/dashboard');
            } else {
                Notiflix.Report.failure(data.message || 'Login failed');
            }
        } catch (error) {
            Notiflix.Report.failure('An error occurred. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const registerUser = async (email, password, name) => {
        setIsLoading(true);
        try {
            const response = await fetch(`${endpoint}/gymapp/register.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password, name }),
            });

            const data = await response.json();

            if (data.status === 'success') {
                localStorage.setItem('authToken', data.user.token);
                localStorage.setItem('userData', JSON.stringify(data.user));
                setUser(data.user);
                setIsAuthenticated(true);
                navigate('/dashboard');
            } else {
                Notiflix.Report.failure(data.message || 'Registration failed');
            }
        } catch (error) {
            Notiflix.Report.failure('An error occurred. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const logoutUser = async () => {
        const token = localStorage.getItem('authToken');

        if (!token) {
            navigate('/login');
            return;
        }

        try {
            const response = await fetch(`${endpoint}/gymapp/logout.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token }),
            });

            const data = await response.json();

            if (data.status === 'success') {
                localStorage.removeItem('authToken');
                localStorage.removeItem('userData');
                setUser(null);
                setIsAuthenticated(false);
                navigate('/login');
            } else {
                Notiflix.Report.failure(data.message || 'Logout failed');
            }
        } catch (error) {
            Notiflix.Report.failure('An error occurred. Please try again.');
        }
    };

       const updateUser = async (formData) => {
        try {
            const response = await fetch(`${endpoint}/gymapp/editProfile.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...formData,
                    token: localStorage.getItem('authToken'),
                }),
            });

            const result = await response.json();

            if (result.status === 'success') {
                localStorage.setItem("userData", JSON.stringify(formData));
                setUser(formData);
                //setEditMode(false);
                Notiflix.Notify.info(result.message);
                //setIsVerifying(false); // Close verification overlay if active
				window.location.reload(); // Proceed to update profile after successful verification
            
            } else {
                Notiflix.Report.failure(result.message || 'Failed to update profile.');
            }
        } catch (error) {
            Notiflix.Report.failure('An error occurred. Please try again.');
        }
    };

    return (
        <UserContext.Provider value={{ updateUser,user, isAuthenticated, loginUser, registerUser, logoutUser, isLoading }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);